// import React, {
//   useEffect,
//   useState,
//   useCallback,
//   useMemo,
//   useRef,
//   Dispatch,
//   SetStateAction,
//   memo,
// } from 'react';
// import { Carousel } from 'antd';
// import VerticalLine from '../../../assets/images/ranking_title_2026/Vertical Line.png';
// import GroupLogo from '../../../assets/images/ranking_title_2026/GroupLogo.png';
// import { useAppSelector, useAppDispatch } from '../../../hooks';
// import { IMAGE_BASE_URL_OF_USER_RANK, IMAGE_BASE_URL_OF_USER } from '../../../constants';
// import { getToken } from 'helpers';
// import { rankingAction } from 'slices/rankingSlice';
// import {
//   isImage,
//   isVideo,
//   monthTitleStardamGroupTitle,
//   rankingNumberOrderStardamGroupTitleNumber,
// } from 'helpers/functionHelper';
// import moment from 'moment';
// import { DisplayScreenType, NoteAppRankingTypes, NoteStyleConfig } from 'models';
// import { useDimension } from 'hooks/useDimension';
// import { useAutoFontSize } from 'hooks/useAutoFontSize';

// interface LayoutSlideProps {
//   displayData: any;
//   nameRunning: any;
//   programRank: any;
//   setCurrentRankingItemRunning: Dispatch<SetStateAction<number>>;
//   setCurrentTypeDisplayOnScreen: Dispatch<SetStateAction<DisplayScreenType>>;
//   currentRankingItemRunning: number;
// }

// export function LayoutSlide({
//   displayData,
//   nameRunning,
//   programRank,
//   setCurrentRankingItemRunning,
//   currentRankingItemRunning,
//   setCurrentTypeDisplayOnScreen,
// }: LayoutSlideProps) {
//   const key =
//     nameRunning === 'PROFIT_DAY'
//       ? 'disable_profit_day'
//       : nameRunning === 'PROFIT_MONTH'
//         ? 'disable_profit_month'
//         : nameRunning === 'NOMINATION_DAY'
//           ? 'disable_nomination_day'
//           : 'disable_nomination_month';

//   const dispatch = useAppDispatch();
//   const token = getToken() as string;

//   const { isSquareView } = useDimension();
//   const { recalc, register } = useAutoFontSize();

//   const carouselRef = useRef<any>(null);
//   const prevIndexRef = useRef<number>(0);
//   const [dimensions, setDimensions] = useState({ height: 0, width: 0 });
//   const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

//   const handleImageLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
//     const { naturalHeight, naturalWidth } = e.currentTarget;
//     setDimensions({ height: naturalHeight, width: naturalWidth });
//   };

//   const [imageError, setImageError] = useState<{ [key: string]: boolean }>({});

//   const selectShop = useAppSelector((state) => state.shopList.selectShop);
//   const noteAppRanking = useAppSelector((state) => state.ranking.noteAppRanking);
//   const notePositionAppRanking = useAppSelector((state) => state.ranking.notePositionAppRanking);
//   const orderByImagesSliderRank = useAppSelector((state) => state.ranking.orderByImagesSliderRank);
//   const shopList = useAppSelector((state) => state.shopList.listShop);

//   const shopInfoRanking = (shopItem: any) => {
//     const shopFound = shopList.find((item) => item.id === shopItem?.shop_id);

//     return shopFound;
//   };

//   const data = displayData?.object;

//   const relatedItems = data[currentRankingItemRunning]?.relatedItems ?? [];
//   const ranks = noteAppRanking.filter((x: any) => x[key] === 1).map((i) => i.rank);
//   // don't know why we have this filter (feat or bug something), so do not delete it
//   // const filteredList = relatedItems.filter((i: any) => !ranks.includes(i.rank));
//   const filteredList = relatedItems;
//   const secondChange = Number(displayData?.secondChange) * 1000 || 10000;
//   const slides = useMemo(() => {
//     if (Array.isArray(relatedItems) && relatedItems.length > 0) {
//       return filteredList?.slice(0, 10);
//     }

//     return data?.[currentRankingItemRunning];
//   }, [displayData, filteredList, currentRankingItemRunning, relatedItems]);

//   const slideCount = filteredList.length || 1;
//   const autoplaySpeedPerSlide = Math.max(Math.round(secondChange / slideCount), 1000);

//   const shopIds = useMemo(() => {
//     return Array.from(
//       new Set(
//         orderByImagesSliderRank
//           ?.map(
//             (item: any) =>
//               item?.order_by_images_slider_ranking?.select_shop_id ??
//               item?.select_shop_id ??
//               item?.shop_id ??
//               selectShop?.id
//           )
//           ?.filter(Boolean)
//       )
//     );
//   }, [orderByImagesSliderRank, selectShop?.id]);

//   const checkShopStardamGroup = useMemo(() => {
//     const currentShopId =
//       data?.[currentRankingItemRunning]?.infoItem?.select_shop_id ?? selectShop?.id;

//     if (!currentShopId) return false;

//     const findShopInfoByCurrentShopId = shopList.find((item) => item.id === currentShopId);

//     return findShopInfoByCurrentShopId?.group_shop === 1;
//   }, [currentRankingItemRunning, data, shopList, selectShop?.id]);

//   const isStandbyItem = (item: any) => {
//     return typeof item?.link === 'string' && item.link.length > 0;
//   };

//   const getStyleConfig = (
//     noteItem?: Partial<NoteAppRankingTypes> | null
//   ): NoteStyleConfig | null => {
//     if (!noteItem?.font) {
//       return null;
//     }

//     return {
//       font: noteItem.font || 'NotoSansNormal',
//       font_size: noteItem.font_size || 40,
//       color: noteItem.color || '#E9EAEB',
//       stroke_color: noteItem.stroke_color || '#252B37',
//       stroke_width: noteItem.stroke_width || 10,
//     };
//   };

//   const getNoteRankingByHost = (item: any) => {
//     return (
//       noteAppRanking.find(
//         (noteItem: any) =>
//           !noteItem.order_by_image_slider_ranking_id &&
//           noteItem?.user_id === item?.id &&
//           noteItem?.note
//       )?.note || ''
//     );
//   };

//   // from No1 to No10 (15/1/2026) => future can be from No1 to No + number
//   const getNoteRankingByRankOrder = (item: any) => {
//     return (
//       notePositionAppRanking.find(
//         (noteItem: any) =>
//           !noteItem.order_by_image_slider_ranking_id &&
//           noteItem?.rank === item?.rank &&
//           noteItem?.note
//       )?.note || ''
//     );
//   };

//   const renderNoteRanking = (item: any, type: 'host' | 'rankingOrder') => {
//     if (!item) return <></>;
//     const noteStyleByHost = noteAppRanking.find(
//       (noteItem: any) =>
//         !noteItem.order_by_image_slider_ranking_id &&
//         noteItem?.user_id === item?.id &&
//         noteItem?.note
//     );
//     const noteStyleByRankingOrderBy = notePositionAppRanking
//       .filter((noteItem: any) => !noteItem.user_id)
//       .find(
//         (noteItem: any) =>
//           !noteItem.order_by_image_slider_ranking_id &&
//           noteItem?.rank === item?.rank &&
//           noteItem?.note
//       );
//     const findNoteConfigByItem = type == 'host' ? noteStyleByHost : noteStyleByRankingOrderBy;
//     const styleConfig = getStyleConfig(findNoteConfigByItem);
//     if (!styleConfig) {
//       return (
//         <span className="inline-block relative text-4xl leading-none whitespace-nowrap notoserif_bold">
//           <span className="absolute inset-0 pointer-events-none stroke-only">
//             {type == 'host' ? getNoteRankingByHost(item) : getNoteRankingByRankOrder(item)}
//           </span>
//           <span className="text-white text-date">
//             {type == 'host' ? getNoteRankingByHost(item) : getNoteRankingByRankOrder(item)}
//           </span>
//         </span>
//       );
//     }

//     return (
//       <span
//         className="whitespace-nowrap"
//         style={{
//           fontFamily: styleConfig.font,
//           fontSize: `${Math.min(styleConfig.font_size, 40)}px`,
//           color: styleConfig.color,
//         }}
//       >
//         {type == 'host' ? getNoteRankingByHost(item) : getNoteRankingByRankOrder(item)}
//       </span>
//     );
//   };

//   const handleAfterChange = useCallback(
//     (current: number) => {
//       if (slides.length <= 1) return;

//       if (prevIndexRef.current === slides.length - 1 && current === 0) {
//         setCurrentRankingItemRunning((prev) => {
//           const max = data?.length ?? 1;

//           // if current ranking item is the last item in data, reset to 0
//           if (prev === max - 1) {
//             return 0;
//           }
//           // else, set + 1
//           return prev + 1;
//         });
//       }

//       setCurrentSlideIndex(current);
//       prevIndexRef.current = current;
//     },
//     [slides.length, data?.length]
//   );

//   // get note by host name with user_id
//   const getListNoteAppRanking = useCallback(() => {
//     if (!programRank?.id || !shopIds.length) return;

//     shopIds.forEach((shopId) => {
//       dispatch(
//         rankingAction.getNoteAppRanking({
//           token,
//           params: {
//             shop_id: String(shopId),
//             type: 2,
//             // program_rank_id: programRank.id,
//           },
//         })
//       );
//     });
//   }, [dispatch, token, shopIds, programRank?.id]);

//   // get note by ranking order_by (No1 => No....)
//   const getListNotePositionAppRanking = useCallback(() => {
//     if (!shopIds.length) return;

//     shopIds.forEach((shopId) => {
//       dispatch(
//         rankingAction.getNotePositionAppRanking({
//           token,
//           params: {
//             shop_id: String(shopId),
//           },
//         })
//       );
//     });
//   }, [dispatch, token, shopIds]);

//   useEffect(() => {
//     if (data?.[currentRankingItemRunning]?.id) {
//       const videoEl = document.getElementById(
//         `myVideo${data?.[currentRankingItemRunning]?.id}`
//       ) as HTMLVideoElement | null;
//       if (data?.[currentRankingItemRunning]?.link.includes('.mp4')) {
//         videoEl?.play().catch((err) => {
//           console.warn('Autoplay blocked:', err);
//         });
//       } else {
//         videoEl?.pause();
//       }
//     }
//   }, [data?.[currentRankingItemRunning]?.id]);

//   useEffect(() => {
//     getListNotePositionAppRanking();
//   }, [getListNotePositionAppRanking]);

//   useEffect(() => {
//     getListNoteAppRanking();
//   }, [getListNoteAppRanking]);

//   useEffect(() => {
//     if (!slides?.length) return;

//     const timer = setInterval(() => {
//       if (slides.length > 1) {
//         carouselRef.current?.next();
//       }
//     }, autoplaySpeedPerSlide);

//     return () => clearInterval(timer);
//   }, [slides?.length, autoplaySpeedPerSlide]);

//   useEffect(() => {
//     const currentItem = displayData?.object?.[currentRankingItemRunning];
//     if (!currentItem) return;

//     // Nếu là image/video (standby)
//     if (isStandbyItem(currentItem)) {
//       const timer = setTimeout(() => {
//         setCurrentRankingItemRunning((prev) => {
//           const max = displayData?.object?.length || 1;
//           return (prev + 1) % max;
//         });
//       }, secondChange);

//       return () => clearTimeout(timer);
//     }
//   }, [currentRankingItemRunning, displayData?.object, secondChange]);

//   useEffect(() => {
//     const currentItem = data[currentRankingItemRunning];

//     let nextType: DisplayScreenType = '';

//     if (!currentItem) {
//       setCurrentTypeDisplayOnScreen('');
//       return;
//     }

//     // 1. Video
//     if (isVideo(currentItem)) {
//       nextType = 'stand-by-video';
//     }
//     // 2. Image
//     else if (isImage(currentItem)) {
//       nextType = 'stand-by-image';
//     }
//     // 3. Ranking by date or month
//     else if (Array.isArray(currentItem?.relatedItems) && currentItem.relatedItems.length > 0) {
//       if (currentItem.type === 'month') {
//         nextType = 'ranking-month';
//       } else if (currentItem.type === 'date') {
//         nextType = 'ranking-day';
//       }
//     }

//     setCurrentTypeDisplayOnScreen(nextType);
//   }, [currentRankingItemRunning, data]);

//   useEffect(() => {
//     if (slides.length !== 1) return;

//     const timer = setTimeout(() => {
//       setCurrentRankingItemRunning((prev) => prev + 1);
//     }, secondChange);

//     return () => clearTimeout(timer);
//   }, [slides.length, secondChange]);

//   // recalculate shop name size on header title
//   useEffect(() => {
//     const t = setTimeout(() => {
//       recalc();
//     }, 100);

//     return () => clearTimeout(t);
//   }, [currentRankingItemRunning, currentSlideIndex]);

//   const isValidDimensions = dimensions?.width > 0 && dimensions?.height > 0;
//   return (
//     <div className="w-screen h-full">
//       {/* <div className="w-full h-[10vh] flex items-center justify-end p-3">
//         {checkShopStardamGroup ? (
//           <img src={monthTitleStardamGroupTitle[moment().month() + 1]} alt="" />
//         ) : (
//           <></>
//         )}
//       </div> */}
//       <div
//         className={`${
//           Array.isArray(filteredList) && 'border-t-[5px] border-white'
//         } w-full h-full layout_carousel`}
//       >
//         {Array.isArray(filteredList) && filteredList.length > 0 ? (
//           <Carousel
//             ref={carouselRef}
//             dots={slides.length > 1 ? { className: 'flex !w-full px-2 gap-1' } : false}
//             autoplaySpeed={autoplaySpeedPerSlide}
//             infinite
//             afterChange={handleAfterChange}
//           >
//             {filteredList?.slice(0, 10).map((item: any, idx: number) => (
//               <div className={`w-full h-screen`} key={`${item.id}-${idx}`}>
//                 {/* <div className={`w-full h-[90vh]`} key={item.id}> */}
//                 <div className="flex justify-center items-center w-full h-full">
//                   <div className="flex relative justify-center items-center h-full w-fit">
//                     <div className="flex justify-center items-center w-full h-full">
//                       {item?.avatar_ranking ? (
//                         <img
//                           onLoad={handleImageLoad}
//                           className="object-contain w-full h-full"
//                           src={`${IMAGE_BASE_URL_OF_USER}/avatar_ranking_user_shop/${item.avatar_ranking}`}
//                           onError={() => {
//                             if (!imageError[item?.id]) {
//                               setImageError((prev) => ({ ...prev, [item?.id]: true }));
//                             }
//                           }}
//                         />
//                       ) : (
//                         <div className="w-screen h-full"></div>
//                       )}
//                     </div>

//                     {checkShopStardamGroup ? (
//                       <div
//                         className={`absolute top-0 right-0 flex justify-center w-full pt-5 ${
//                           isValidDimensions && dimensions.width === dimensions.height
//                             ? 'max-h-[130px]'
//                             : 'max-h-[210px] px-3'
//                         } h-fit`}
//                       >
//                         <div
//                           className={`flex flex-col items-end justify-between max-w-[25%] w-fit ${
//                             isValidDimensions && dimensions.width === dimensions.height
//                               ? 'h-[110px]'
//                               : isSquareView
//                                 ? 'h-[190px]'
//                                 : 'h-[200px]'
//                           } pt-2 object-contain`}
//                         >
//                           <img src={GroupLogo} alt="Group Stardam" className="object-cover" />

//                           <p
//                             key={`${item.id}-${idx}`}
//                             ref={register(26, 50)}
//                             className="
//                               w-full
//                               font-hgs-minchoE
//                               text-[#FFF691]
//                               whitespace-nowrap
//                               text-right
//                               leading-none
//                             "
//                           >
//                             {shopInfoRanking(data[currentRankingItemRunning])?.name}
//                           </p>
//                         </div>
//                         <img
//                           src={VerticalLine}
//                           alt="vertical line"
//                           className={`ml-4 ${
//                             isValidDimensions && dimensions.width === dimensions.height
//                               ? 'max-h-[110px]'
//                               : isSquareView
//                                 ? 'max-h-[190px]'
//                                 : 'max-h-[210px]'
//                           } h-fit`}
//                         />
//                         <img
//                           className={`max-w-[70%] w-fit object-contain`}
//                           src={monthTitleStardamGroupTitle[moment().month() + 1]}
//                           alt=""
//                         />
//                       </div>
//                     ) : (
//                       <></>
//                     )}
//                     <div className="flex absolute bottom-0 justify-between w-full">
//                       <div className="flex flex-col gap-10 pt-10 w-1/3" style={{ paddingLeft: 30 }}>
//                         <span
//                           key={`${item.id}-${idx}`}
//                           ref={register(40, 90)}
//                           className="inline-block relative w-full leading-none whitespace-nowrap notoserif_black"
//                         >
//                           <div className="pt-10 w-full">
//                             <span className="absolute inset-0 pt-10 pointer-events-none stroke-only">
//                               {item?.nick_name}
//                             </span>
//                             <span className="text-gradient">{item?.nick_name}</span>
//                           </div>
//                         </span>
//                         {/* NOTE RANKING */}
//                         <div className="space-y-5">
//                           <div>{renderNoteRanking(item, 'host')}</div>
//                           <div>{renderNoteRanking(item, 'rankingOrder')}</div>
//                         </div>
//                       </div>
//                       <img
//                         src={rankingNumberOrderStardamGroupTitleNumber[idx + 1]}
//                         alt=""
//                         className="object-contain w-2/3 h-fit"
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </Carousel>
//         ) : (
//           <div className="relative w-full h-screen">
//             {displayData?.object?.[currentRankingItemRunning]?.link?.includes('.mp4') ? (
//               <video
//                 id={`myVideo${displayData?.object?.[currentRankingItemRunning]?.id}`}
//                 controls={false}
//                 width="100%"
//                 className={`object-contain w-full h-full`}
//                 autoPlay
//                 loop={true}
//               >
//                 <source
//                   src={`${IMAGE_BASE_URL_OF_USER_RANK}/images_slider/${displayData?.object?.[currentRankingItemRunning]?.link}`}
//                   type="video/mp4"
//                 />
//               </video>
//             ) : (
//               <img
//                 src={`${IMAGE_BASE_URL_OF_USER_RANK}/images_slider/${displayData?.object?.[currentRankingItemRunning]?.link}`}
//                 className={`object-contain w-full h-full`}
//               />
//             )}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default memo(LayoutSlide);
import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
  Dispatch,
  SetStateAction,
  memo,
  useLayoutEffect,
} from 'react';
import { Carousel } from 'antd';
import VerticalLine from '../../../assets/images/ranking_title_2026/Vertical Line.png';
import GroupLogo from '../../../assets/images/ranking_title_2026/GroupLogo.png';
import { useAppSelector } from '../../../hooks';
import { IMAGE_BASE_URL_OF_USER_RANK, IMAGE_BASE_URL_OF_USER } from '../../../constants';
import HorizontalSplitLine from '../../../assets/images/ranking_title_split_2026/LINE.png';
import RankingTitleNoShopName from '../../../assets/images/ranking_title_2026/ranking_title_2026_no_shop_name.png';
import {
  appointeeNoOrder,
  appointeeSubtitleTop10,
  appointeeSubtitleTop20,
  dayAppointeeTitle,
  daySaleTitle,
  isImage,
  isVideo,
  monthAppointeeTitle,
  monthSaleTitle,
  saleNoOrder,
  saleSubtitleTop10,
  saleSubtitleTop20,
} from 'helpers/functionHelper';
import moment from 'moment';
import { DisplayScreenType, NoteAppRankingTypes, NoteStyleConfig } from 'models';
import { useDimension } from 'hooks/useDimension';
import { useAutoFontSize } from 'hooks/useAutoFontSize';
import { useWindowSize } from 'components/Common/UseWindowSize';

interface LayoutSlideProps {
  displayData: any;
  nameRunning: any;
  setCurrentRankingItemRunning: Dispatch<SetStateAction<number>>;
  setCurrentTypeDisplayOnScreen: Dispatch<SetStateAction<DisplayScreenType>>;
  currentTypeDisplayOnScreen: DisplayScreenType;
  currentRankingItemRunning: number;
}

// Split Memoize SlideContent component
const SlideContent = memo(
  ({
    item,
    idx,
    checkShopStardamGroup,
    dimensions,
    isValidDimensions,
    isSquareView,
    shopInfoRanking,
    data,
    currentRankingItemRunning,
    renderNoteRanking,
    handleImageLoad,
    imageError,
    setImageError,
    register,
    nameRunning,
    isOverTop10,
  }: any) => {
    const { width, height } = useWindowSize();
    const __renderTitleByNameRunning = () => {
      const nameRunningMap = {
        PROFIT_DAY: daySaleTitle,
        PROFIT_MONTH: monthSaleTitle[moment().month() + 1],
        NOMINATION_DAY: dayAppointeeTitle,
        NOMINATION_MONTH: monthAppointeeTitle[moment().month() + 1],
      };
      return nameRunningMap[nameRunning as keyof typeof nameRunningMap];
    };

    const __renderSubTitleByNameRunning = () => {
      const nameRunningMap = {
        PROFIT_DAY: isOverTop10 ? saleSubtitleTop20 : saleSubtitleTop10,
        PROFIT_MONTH: isOverTop10 ? saleSubtitleTop20 : saleSubtitleTop10,
        NOMINATION_DAY: isOverTop10 ? appointeeSubtitleTop20 : appointeeSubtitleTop10,
        NOMINATION_MONTH: isOverTop10 ? appointeeSubtitleTop20 : appointeeSubtitleTop10,
      };
      return nameRunningMap[nameRunning as keyof typeof nameRunningMap];
    };

    const __renderNumberOrderByNameRunning = () => {
      const nameRunningMap = {
        PROFIT_DAY: saleNoOrder[idx + 1],
        PROFIT_MONTH: saleNoOrder[idx + 1],
        NOMINATION_DAY: appointeeNoOrder[idx + 1],
        NOMINATION_MONTH: appointeeNoOrder[idx + 1],
      };
      return nameRunningMap[nameRunning as keyof typeof nameRunningMap];
    };

    return (
      <div className={`w-full h-screen`}>
        <div
          className={`relative flex flex-col items-center h-screen mx-auto min-w-[40%] w-full ${Math.abs(width - height) < 500 ? '' : 'max-w-[55%]'}`}
        >
          {checkShopStardamGroup ? (
            // old title, ful width
            // <div
            //   // className={`flex justify-center w-full gap-2 pt-5 ${
            //   //   isValidDimensions && dimensions.width === dimensions.height
            //   //     ? 'max-h-[130px]'
            //   //     : 'max-h-[210px] px-3'
            //   // } h-fit`}
            //   className={`flex justify-center w-full gap-2 ${
            //     isValidDimensions && dimensions.width === dimensions.height
            //       ? 'max-h-[100px]'
            //       : 'max-h-[210px] px-3'
            //   } h-fit`}
            // >
            //   <div
            //     // className={`flex flex-col items-end justify-between max-w-[25%] w-fit ${
            //     //   isValidDimensions && dimensions.width === dimensions.height
            //     //     ? 'h-[120px]'
            //     //     : isSquareView
            //     //       ? 'h-[120px]'
            //     //       : 'h-[200px]'
            //     // } pt-2 object-contain`}
            //     className={`flex flex-col items-end min-h-[100px] justify-between max-w-[30%] w-fit object-contain h-full`}
            //   >
            //     <img src={GroupLogo} alt="Group Stardam" className="object-contain h-16" />

            //     <p
            //       key={`${item.id}-${idx}`}
            //       ref={register(26, 36)}
            //       className="
            //         w-full
            //         font-hgs-minchoE
            //         text-[#FFF691]
            //         whitespace-nowrap
            //         text-right
            //         leading-none
            //       "
            //     >
            //       {shopInfoRanking(data[currentRankingItemRunning], idx)}
            //     </p>
            //   </div>
            //   <img
            //     src={VerticalLine}
            //     alt="vertical line"
            //     // className={`ml-4 ${
            //     //   isValidDimensions && dimensions.width === dimensions.height
            //     //     ? 'max-h-[120px]'
            //     //     : isSquareView
            //     //       ? 'max-h-[120px]'
            //     //       : 'max-h-[210px]'
            //     // } h-fit`}
            //     className={`max-h-[90px] h-fit`}
            //   />
            //   <div className="flex flex-col items-center justify-center space-y-4 max-w-[75%] h-full max-h-[90px]">
            //     <img
            //       className={`object-contain max-w-[90%] w-fit max-h-12 h-full`}
            //       src={__renderTitleByNameRunning()}
            //       alt=""
            //     />
            //     <img src={HorizontalSplitLine} alt="vertical line" />
            //     <img
            //       src={__renderSubTitleByNameRunning()}
            //       alt=""
            //       className="object-contain max-w-[90%] w-fit"
            //     />
            //   </div>
            // </div>

            // new but with shop name
            <div
              className={`flex justify-end w-full gap-2 ${
                isValidDimensions && dimensions.width === dimensions.height
                  ? 'max-h-[100px]'
                  : 'max-h-[210px] px-3'
              } h-fit`}
            >
              <div className="flex w-[70%]">
                <div
                  className={`flex flex-col items-end min-h-[100px] gap-2 max-w-[30%] w-fit object-contain h-full`}
                >
                  <img src={GroupLogo} alt="Group Stardam" className="object-contain h-16" />

                  <p
                    key={`${item.id}-${idx}`}
                    ref={register(20, 28)}
                    className="
                    w-full
                    font-hgs-minchoE
                    text-[#FFF691]
                    whitespace-nowrap
                    text-right
                    leading-none
                  "
                  >
                    {shopInfoRanking(data[currentRankingItemRunning], idx)}
                  </p>
                </div>
                <img src={VerticalLine} alt="vertical line" className={`max-h-[90px] h-fit`} />
                <div className="flex flex-col items-center justify-center space-y-4 w-full h-full max-h-[90px]">
                  <img
                    className={`object-contain max-w-[90%] w-fit max-h-12 h-full`}
                    src={__renderTitleByNameRunning()}
                    alt=""
                  />
                  <img src={HorizontalSplitLine} alt="vertical line" />
                  <img
                    src={__renderSubTitleByNameRunning()}
                    alt=""
                    className="object-contain max-w-[90%] w-fit"
                  />
                </div>
              </div>
            </div>
          ) : (
            // new title with width 1/2
            // <div className="w-full flex justify-end h-fit">
            //   <div className={`w-1/2 my-3`}>
            //     <img
            //       src={RankingTitleNoShopName}
            //       alt=""
            //       className="object-contain h-full w-fit"
            //       onLoad={handleImageLoad}
            //     />
            //   </div>
            // </div>
            <></>
          )}
          <div className="flex w-full h-[calc(100vh-80px)]">
            {item?.avatar_ranking ? (
              <img
                onLoad={handleImageLoad}
                className="w-full h-full aspect-[480/449] "
                src={`${IMAGE_BASE_URL_OF_USER}/avatar_ranking_user_shop/${item.avatar_ranking}`}
                onError={() => {
                  if (!imageError[item?.id]) {
                    setImageError((prev: any) => ({ ...prev, [item?.id]: true }));
                  }
                }}
                style={{
                  objectFit: Boolean(dimensions.scale < 480 / 449) ? 'cover' : 'contain',
                }}
              />
            ) : (
              <div className="w-full h-screen"></div>
            )}
          </div>

          <div className="flex absolute bottom-3 justify-between w-full">
            <div className="flex flex-col gap-7 pt-10 w-1/3" style={{ paddingLeft: 30 }}>
              <span
                key={`${item.id}-${idx}`}
                ref={register(40, 90)}
                className="inline-block relative w-full leading-none whitespace-nowrap notoserif_black"
              >
                <div className="pt-10 w-full">
                  <span className="absolute inset-0 pt-10 pointer-events-none stroke-only">
                    {item?.nick_name}
                  </span>
                  <span className="text-gradient">{item?.nick_name}</span>
                </div>
              </span>
              <div className="pb-3 space-y-3">
                <div>{renderNoteRanking(item, 'host')}</div>
                <div>{renderNoteRanking(item, 'rankingOrder')}</div>
              </div>
            </div>
            <img
              src={__renderNumberOrderByNameRunning()}
              alt=""
              className="object-contain w-1/2 h-fit"
            />
          </div>
        </div>
      </div>
    );
  },
  // https://kungfutech.edu.vn/cau-hoi-phong-van/how-to-use-reactmemo
  // Optionally, you can provide a second argument to React.memo() —
  // a custom comparison function that tells React how to compare the old props with the new ones.
  // This function should return  if the props are equal (i.e., the component should not re-render)
  // and if they are not equal (i.e., the component should re-render).
  // Custom comparison function
  (prevProps, nextProps) => {
    return (
      prevProps.item.id === nextProps.item.id &&
      prevProps.idx === nextProps.idx &&
      prevProps.checkShopStardamGroup === nextProps.checkShopStardamGroup &&
      prevProps.dimensions === nextProps.dimensions &&
      prevProps.isValidDimensions === nextProps.isValidDimensions &&
      prevProps.currentRankingItemRunning === nextProps.currentRankingItemRunning
    );
  }
);

SlideContent.displayName = 'SlideContent';

const LayoutSlide: React.FC<LayoutSlideProps> = ({
  displayData,
  nameRunning,
  setCurrentRankingItemRunning,
  currentRankingItemRunning,
  setCurrentTypeDisplayOnScreen,
  currentTypeDisplayOnScreen,
}: LayoutSlideProps) => {
  const key =
    nameRunning === 'PROFIT_DAY'
      ? 'disable_profit_day'
      : nameRunning === 'PROFIT_MONTH'
        ? 'disable_profit_month'
        : nameRunning === 'NOMINATION_DAY'
          ? 'disable_nomination_day'
          : 'disable_nomination_month';

  const { isSquareView } = useDimension();
  const { recalc, register } = useAutoFontSize();

  const carouselRef = useRef<any>(null);
  const prevIndexRef = useRef<number>(0);
  const [dimensions, setDimensions] = useState({ scale: 0, height: 0, width: 0 });
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  // nếu aspect ratio nhỏ hơn expected ratio thì cho cover hoặc chỉnh hình ra theo contain, còn không giữ nguyên aspect ratio
  const handleImageLoad = useCallback((e: React.SyntheticEvent<HTMLImageElement>) => {
    const { naturalHeight, naturalWidth, clientHeight, clientWidth } = e.currentTarget;
    const scale = naturalWidth / naturalHeight;
    // const scale = Math.min(clientWidth / clientHeight, containerHeight / imageHeight);
    console.log('scale: ', scale);
    setDimensions({ height: naturalHeight * scale, width: naturalWidth * scale, scale });
  }, []);
  const [imageError, setImageError] = useState<{ [key: string]: boolean }>({});

  const selectShop = useAppSelector((state) => state.shopList.selectShop);
  const noteAppRanking = useAppSelector((state) => state.ranking.noteAppRanking);
  const notePositionAppRanking = useAppSelector((state) => state.ranking.notePositionAppRanking);
  const shopList = useAppSelector((state) => state.shopList.listShop);
  const masterInfo = useAppSelector((state) => state.auth.masterInfo);

  const data = displayData?.object;
  const isMaster = masterInfo.active && !selectShop.id;

  const nextLayout = data[currentRankingItemRunning + 1]?.link
    ? 0
    : (data[currentRankingItemRunning + 1]?.layout_ranking ?? 0);

  const shopInfoRanking = useCallback(
    (shopItem: any, index?: number) => {
      const hasGroup = shopItem?.relatedItems?.some((item: any) => item?.shop?.id);
      if (hasGroup && typeof index === 'number') {
        return shopItem?.relatedItems?.[index]?.shop?.name || '';
      }

      const shopFound = shopList.find((item) => item.id === shopItem?.shop_id);

      return shopFound?.name || '';
    },
    [shopList]
  );

  const relatedItems: Array<any> = data[currentRankingItemRunning]?.relatedItems;
  // const ranks = noteAppRanking.filter((x: any) => x[key] === 1).map((i) => i.rank);
  const secondChange =
    Number(displayData?.object[currentRankingItemRunning]?.secondChange) * 1000 || 30000;
  // const secondChange = 9000000;
  const isValidDimensions = dimensions?.width > 0 && dimensions?.height > 0;

  const limitByQuantityStaff = () => {
    const currentData = data[currentRankingItemRunning].infoItem;
    if (currentData.layout_quantity_user_slider_ranking === 0) {
      return 10;
    }
    return currentData.quantity_user_slider_app_rank ?? 10;
  };

  const slides = useMemo(() => {
    if (Array.isArray(relatedItems) && relatedItems.length > 0) {
      // return filteredList;
      return relatedItems?.slice(0, limitByQuantityStaff());
    }
    return data?.[currentRankingItemRunning];
  }, [displayData, relatedItems, currentRankingItemRunning, relatedItems]);

  const slideCount = limitByQuantityStaff() || 10;

  // const autoplaySpeedPerSlide = useMemo(
  //   () => Math.max(Math.round(secondChange / slideCount), 1000),
  //   [secondChange, slideCount]
  // );

  const autoplaySpeedPerSlideBySumRelatedItems = useMemo(() => {
    const totalSlides = data
      .filter((item: any) => item.type === 'date')
      .reduce((acc: any, item: any) => {
        if (item?.relatedItems?.length == 0) return acc;
        if (item?.relatedItems?.length > 10) return (acc += 10);
        if (item?.relatedItems?.length <= 10) return (acc += item?.relatedItems?.length || 0);
      }, 0);
    if (currentTypeDisplayOnScreen === 'ranking-month') return secondChange / slideCount;

    if (totalSlides === 0) return 1000;

    const speed = secondChange / totalSlides;

    return speed < 1000 ? 1000 : speed;
  }, [data, secondChange, currentTypeDisplayOnScreen, slideCount]);

  const checkShopStardamGroup = useMemo(() => {
    const currentShopId =
      data?.[currentRankingItemRunning]?.infoItem?.select_shop_id ?? selectShop?.id;

    if (isMaster) {
      if (data?.[currentRankingItemRunning]?.infoItem?.ranking_list_shop?.length > 0) return true;
    } else {
      if (!currentShopId) return false;
    }

    const findShopInfoByCurrentShopId = shopList.find((item) => item.id === currentShopId);

    return findShopInfoByCurrentShopId?.group_shop === 1;
  }, [currentRankingItemRunning, data, shopList, selectShop?.id]);

  const isStandbyItem = (item: any) => {
    return typeof item?.link === 'string' && item.link.length > 0;
  };

  const getStyleConfig = (
    noteItem?: Partial<NoteAppRankingTypes> | null
  ): NoteStyleConfig | null => {
    if (!noteItem?.font) {
      return null;
    }

    return {
      font: noteItem.font || 'NotoSansNormal',
      font_size: noteItem.font_size || 40,
      color: noteItem.color || '#E9EAEB',
      stroke_color: noteItem.stroke_color || '#252B37',
      stroke_width: noteItem.stroke_width || 10,
    };
  };

  const carouselKey = useMemo(
    () => `carousel-${currentRankingItemRunning}`,
    [currentRankingItemRunning]
  );

  const getNoteRankingByHost = useCallback(
    (item: any) => {
      return (
        noteAppRanking.find(
          (noteItem: any) =>
            !noteItem.order_by_image_slider_ranking_id &&
            noteItem?.user_id === item?.id &&
            noteItem?.shop_id === item?.shop?.id &&
            noteItem?.note
        )?.note || ''
      );
    },
    [noteAppRanking]
  );

  const getNoteRankingByRankOrder = useCallback(
    (item: any) => {
      return (
        notePositionAppRanking.find(
          (noteItem: any) =>
            !noteItem.order_by_image_slider_ranking_id &&
            noteItem?.rank === item?.rank &&
            noteItem?.shop_id === item?.shop?.id &&
            noteItem?.note
        )?.note || ''
      );
    },
    [notePositionAppRanking]
  );

  const renderNoteRanking = useCallback(
    (item: any, type: 'host' | 'rankingOrder') => {
      if (!item) return <></>;

      const noteStyleByHost = noteAppRanking.find(
        (noteItem: any) =>
          !noteItem.order_by_image_slider_ranking_id &&
          noteItem?.user_id === item?.id &&
          noteItem?.shop_id === item?.shop?.id &&
          noteItem?.note
      );
      const noteStyleByRankingOrderBy = notePositionAppRanking
        .filter((noteItem: any) => !noteItem.user_id)
        .find(
          (noteItem: any) =>
            !noteItem.order_by_image_slider_ranking_id &&
            noteItem?.rank === item?.rank &&
            noteItem?.shop_id === item?.shop?.id &&
            noteItem?.note
        );

      const findNoteConfigByItem = type == 'host' ? noteStyleByHost : noteStyleByRankingOrderBy;
      const styleConfig = getStyleConfig(findNoteConfigByItem);
      if (!styleConfig) {
        return (
          <span className="inline-block relative text-4xl leading-none whitespace-nowrap notoserif_bold">
            <span className="absolute inset-0 pointer-events-none stroke-only">
              {type == 'host' ? getNoteRankingByHost(item) : getNoteRankingByRankOrder(item)}
            </span>
            <span className="text-white text-date">
              {type == 'host' ? getNoteRankingByHost(item) : getNoteRankingByRankOrder(item)}
            </span>
          </span>
        );
      }

      return (
        <span
          className="whitespace-nowrap"
          style={{
            fontFamily: styleConfig.font,
            fontSize: `${Math.min(styleConfig.font_size, 40)}px`,
            color: styleConfig.color,
          }}
        >
          {type == 'host' ? getNoteRankingByHost(item) : getNoteRankingByRankOrder(item)}
        </span>
      );
    },
    [noteAppRanking, notePositionAppRanking, getNoteRankingByHost, getNoteRankingByRankOrder]
  );

  const handleAfterChange = useCallback(
    (current: number) => {
      if (slides.length <= 1) return;

      if (prevIndexRef.current === slides.length - 1 && current === 0) {
        setCurrentRankingItemRunning((prev) => {
          const max = data?.length ?? 1;
          if (prev === max - 1) {
            return 0;
          }
          return prev + 1;
        });
      }

      setCurrentSlideIndex(current);
      prevIndexRef.current = current;
    },
    [slides.length, data?.length, setCurrentRankingItemRunning]
  );

  useEffect(() => {
    if (data?.[currentRankingItemRunning]?.id) {
      const videoEl = document.getElementById(
        `myVideo${data?.[currentRankingItemRunning]?.id}`
      ) as HTMLVideoElement | null;
      if (data?.[currentRankingItemRunning]?.link.includes('.mp4')) {
        videoEl?.play().catch((err) => {
          console.warn('Autoplay blocked:', err);
        });
      } else {
        videoEl?.pause();
      }
    }
  }, [data, currentRankingItemRunning]);

  useEffect(() => {
    if (!slides?.length) return;

    const timer = setInterval(() => {
      if (slides.length > 1) {
        carouselRef.current?.next();
      }
    }, autoplaySpeedPerSlideBySumRelatedItems);

    return () => clearInterval(timer);
  }, [slides?.length, autoplaySpeedPerSlideBySumRelatedItems]);

  useEffect(() => {
    const currentItem = displayData?.object?.[currentRankingItemRunning];
    if (!currentItem) return;

    if (isStandbyItem(currentItem)) {
      const timer = setTimeout(() => {
        setCurrentRankingItemRunning((prev) => {
          const max = displayData?.object?.length || 1;
          return (prev + 1) % max;
        });
      }, secondChange);

      return () => clearTimeout(timer);
    }
  }, [currentRankingItemRunning, displayData?.object, secondChange, setCurrentRankingItemRunning]);

  useEffect(() => {
    const currentItem = data[currentRankingItemRunning];

    let nextType: DisplayScreenType = '';

    if (!currentItem) {
      setCurrentTypeDisplayOnScreen('');
      return;
    }

    if (isVideo(currentItem)) {
      nextType = 'stand-by-video';
    } else if (isImage(currentItem)) {
      nextType = 'stand-by-image';
    } else if (Array.isArray(currentItem?.relatedItems) && currentItem.relatedItems.length > 0) {
      if (currentItem.type === 'month') {
        nextType = 'ranking-month';
      } else if (currentItem.type === 'date') {
        nextType = 'ranking-day';
      }
    }

    setCurrentTypeDisplayOnScreen(nextType);
  }, [currentRankingItemRunning, data, setCurrentTypeDisplayOnScreen]);

  useEffect(() => {
    if (slides.length !== 1) return;

    const timer = setTimeout(() => {
      setCurrentRankingItemRunning((prev) => prev + 1);
    }, secondChange);

    return () => clearTimeout(timer);
  }, [slides.length, secondChange, setCurrentRankingItemRunning]);

  useLayoutEffect(() => {
    const t = setTimeout(() => {
      recalc();
    }, 100);

    return () => clearTimeout(t);
  }, [currentRankingItemRunning, currentSlideIndex, recalc]);
  return (
    <div className="w-screen h-full">
      <div
        className={`${
          Array.isArray(relatedItems) && 'border-t-[5px] border-white'
        } w-full h-full layout_carousel`}
      >
        {Array.isArray(relatedItems) && relatedItems.length > 0 ? (
          <Carousel
            key={carouselKey}
            ref={carouselRef}
            // dots={slides.length > 1 ? { className: 'flex !w-full px-2 gap-1' } : false}
            dots={false}
            autoplaySpeed={autoplaySpeedPerSlideBySumRelatedItems}
            infinite
            beforeChange={(from, to) => {
              if (nextLayout === 0 && to === 0 && from === data.length - 1) {
                carouselRef.current?.goTo(0, false);
                if (to === 0 && from === data.length - 1) {
                  setCurrentRankingItemRunning((prev) => prev + 1);
                }
                return;
              }
            }}
            afterChange={handleAfterChange}
          >
            {slides?.map((item: any, idx: number) => (
              <SlideContent
                key={`${item.id}-${idx}`}
                item={item}
                idx={idx}
                checkShopStardamGroup={checkShopStardamGroup}
                dimensions={dimensions}
                isValidDimensions={isValidDimensions}
                isSquareView={isSquareView}
                shopInfoRanking={shopInfoRanking}
                data={data}
                currentRankingItemRunning={currentRankingItemRunning}
                renderNoteRanking={renderNoteRanking}
                handleImageLoad={handleImageLoad}
                imageError={imageError}
                setImageError={setImageError}
                register={register}
                nameRunning={nameRunning}
                isOverTop10={limitByQuantityStaff() > 10}
              />
            ))}
          </Carousel>
        ) : (
          <div className="relative w-full h-screen">
            {data[currentRankingItemRunning]?.link?.includes('.mp4') ? (
              <video
                id={`myVideo${data[currentRankingItemRunning]?.id}`}
                controls={false}
                width="100%"
                className={`object-contain w-full h-full`}
                autoPlay
                loop={true}
              >
                <source
                  src={`${IMAGE_BASE_URL_OF_USER_RANK}/images_slider/${data[currentRankingItemRunning]?.link}`}
                  type="video/mp4"
                />
              </video>
            ) : (
              <img
                src={`${IMAGE_BASE_URL_OF_USER_RANK}/images_slider/${data[currentRankingItemRunning]?.link}`}
                className={`object-contain w-full h-full`}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(LayoutSlide);
